import React, { useState } from 'react';
import { CardSection } from '../ArticlePage/RelatedArticlesNew/styled';
import { TopicDetailGrid } from '../CategoryDetail/CategoryBanner/styled';
import { StickySection } from '../QnaPage/AskNowSection/styled';
import DiscoverTopics from './DiscoverTopics/DiscoverTopics';
import DesktopFilter from './DesktopFilter/DesktopFilter';
import MobileFilter from './MobileFilter/MobileFilter';
import TopicListingCardCover from './TopicListingCards/TopicListingCardCover';
import { getSearchResults } from '../../datafetchers/HomePage';
import Noresultscreen from './NoResultScreen/Noresultscreen';
import { useDebounce } from 'react-use';
import TopicListingSearchResults from './TopicListingCards/TopicListingSearchResults';
import BrowseRelatedCategory from '../StoreCategoryPage/BrowseRelatedCategory/BrowseRelatedCategory';
import Loader from '../Loader';
import { ShowingResult } from './styled';
import { getScreenName } from '../../Utils/helper';
import Breadcrumbs from '../../../src/components/StoreCategoryPage/Breadcrumbs';
import useSWR from 'swr';
import { fireEvent } from '../../Utils/fireEvent';
import { getWebUserType } from '../../Utils/getWebUserType';

export default function TopicListingPage(props) {
  const { tagsDetails, recommendations, breadCrumbs } = props;
  const [searchData, setSearchData] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [noResultsFound, setNoResultsFound] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const initialData = {
    tagsDetails: tagsDetails,
    selectedFilter: 'all',
  };
  const { data, error, mutate } = useSWR(`topic`, () => {}, {
    fallbackData: initialData,
    revalidateOnMount: false,
  });
  const [, cancel] = useDebounce(
    () => {
      searchHandler(searchString);
    },
    600,
    [searchString],
  );
  const searchHandler = async (searchString) => {
    setNoResultsFound(false);
    if (searchString) {
      const params = {
        q: searchString,
        start: 0,
        filter: 'tags',
        rows: 50,
        userType : getWebUserType(),
      };
      const searchApiData = await getSearchResults(params);
      const searchDataArray = searchApiData?.[0]?.data;
      searchDataArray && searchDataArray?.length > 0
        ? setSearchData(searchDataArray)
        : setNoResultsFound(true);
      fireEvent({
        category: 'search_query',
        screen_name: getScreenName(),
        query: searchString,
        products_result: searchDataArray?.length,
        products_shown: searchDataArray?.map((item) => item.term_id),
        parent: 'topic_search_bar',
      });
    } else {
      setSearchData([]);
      setNoResultsFound(false);
    }
  };
  return (
    <>
      <Breadcrumbs breadCrumbs={breadCrumbs} />
      <TopicDetailGrid>
        <StickySection>
          <MobileFilter
            setShowLoader={setShowLoader}
            mutate={mutate}
            selectedFilter={data?.selectedFilter}
          />
          <CardSection topicList>
            <DesktopFilter
              setShowLoader={setShowLoader}
              mutate={mutate}
              selectedFilter={data?.selectedFilter}
            />
          </CardSection>
        </StickySection>
        <div>
          <DiscoverTopics setSearchString={setSearchString} />
          {showLoader && <Loader />}
          {noResultsFound ? (
            <Noresultscreen
              setSearchString={setSearchString}
              searchString={searchString}
            />
          ) : searchData?.length > 0 ? (
            <>
              <ShowingResult>
                showing {searchData?.length} results for{' '}
                <strong>&quot;{searchString}&quot;</strong>
              </ShowingResult>
              <TopicListingSearchResults cardData={searchData} />
            </>
          ) : (
            <TopicListingCardCover tagsDetails={data?.tagsDetails} />
          )}
        </div>
      </TopicDetailGrid>
      <BrowseRelatedCategory
        title={'Trending topics'}
        categoryFilterData={recommendations}
      />
    </>
  );
}
